export default __webpack_public_path__ + "static/media/calendar-connected-successfully.949d09fc.svg";